var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"borough-selector"},[_c('div',_vm._l((_vm.boroughs),function(borough,index){return _c('button',{key:index,staticClass:"btn btn-outline-primary rounded-pill",class:{ active: _vm.isSelected(borough) },on:{"click":function($event){return _vm.toggleBorough(borough)}}},[_vm._v(" "+_vm._s(borough)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }